import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled, { keyframes } from "styled-components";

// Fun, step-matching emojis for each step
const stepEmojis = [
  "🛋️", "🌬️", "🦶", "🦵", "🦴", "💪", "🤷", "😊", "🧘", "🌞"
];

// Gentle pulse animation for the emoji bubble
const pulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(255,209,102,0.25); }
  70% { box-shadow: 0 0 0 16px rgba(255,209,102,0.07); }
  100% { box-shadow: 0 0 0 0 rgba(255,209,102,0.0); }
`;

const EmojiBubble = styled.div`
  width: 82px;
  height: 82px;
  margin: 0 auto 20px auto;
  border-radius: 50%;
  background: #fffbe6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.7rem;
  animation: ${pulse} 2.2s infinite;
  box-shadow: 0 2px 12px rgba(255,209,102,0.08);
  transition: background 0.4s;
`;

const CuteButton = styled.button`
  padding: 12px 32px;
  border-radius: 20px;
  background: #FFD166;
  color: #222;
  font-weight: 600;
  border: none;
  cursor: pointer;
  font-size: 1.1em;
  margin-top: 12px;
  box-shadow: 0 2px 8px rgba(255,209,102,0.09);
  transition: background 0.2s;
  &:hover { background: #ffe29a; }
`;

const navBtnStyle = {
  background: "#FFD166",
  border: "none",
  borderRadius: 16,
  padding: "8px 20px",
  fontWeight: 600,
  cursor: "pointer",
  marginRight: 10,
  fontSize: "1em"
};

export default function RelaxationTool() {
  const [step, setStep] = useState(0);
  const navigate = useNavigate();

  const steps = [
    "Sit or lie down comfortably. Close your eyes if you like.",
    "Take a slow, deep breath in... and out.",
    "Focus on your feet. Tense the muscles tightly. Hold for 5 seconds... then release.",
    "Move to your legs. Tense your thigh and calf muscles. Hold... and release.",
    "Now your stomach and back. Tighten them. Hold... and let go.",
    "Clench your fists and arms. Hold... then release.",
    "Shrug your shoulders up to your ears. Hold... and relax.",
    "Tighten your face: squeeze eyes shut, scrunch your nose. Hold... and relax.",
    "Scan your body. Notice the difference between tension and relaxation.",
    "Take a few more deep breaths. When you're ready, open your eyes."
  ];

  const handleNext = () => {
    if (step < steps.length - 1) {
      setStep(s => s + 1);
    } else {
      navigate("/");
    }
  };

  const handleBack = () => {
    if (step > 0) {
      setStep(s => s - 1);
    } else {
      if (window.history.state && window.history.state.idx > 0) {
        navigate(-1);
      } else {
        navigate("/");
      }
    }
  };

  const goHome = () => navigate("/");

  return (
    <div style={{
      maxWidth: 500,
      margin: "40px auto",
      background: "#fffbe6",
      borderRadius: 24,
      boxShadow: "0 2px 12px rgba(255,209,102,0.10)",
      padding: 32,
      textAlign: "center",
      border: "2px solid #ffe29a"
    }}>
      {/* Navigation Buttons */}
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginBottom: 10 }}>
        <button onClick={handleBack} style={navBtnStyle}>← Back</button>
        <button onClick={goHome} style={navBtnStyle}>🏠 Home</button>
      </div>
      <h2 style={{ marginBottom: 8 }}>Progressive Muscle Relaxation</h2>
      <p style={{ color: "#b48b1e" }}>
        Follow this simple, evidence-based routine to release tension from your body.
      </p>
      <EmojiBubble>
        {stepEmojis[step]}
      </EmojiBubble>
      <div style={{
        minHeight: 80,
        fontSize: 19,
        margin: "32px 0",
        color: "#444",
        transition: "color 0.2s"
      }}>
        {steps[step]}
      </div>
      <CuteButton onClick={handleNext}>
        {step === steps.length - 1 ? "Done" : "Next"}
      </CuteButton>
    </div>
  );
}
